module.exports = __webpack_public_path__ + "static/media/starts_with_g.6694f7c1.mp3";